import type { AxiosInstance } from 'axios';
import { Gift, GiftList } from './types';
import { PaginateOptions } from '../types';

export class GiftsService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  async list(options: PaginateOptions): Promise<GiftList> {
    const response = await this.instance.get<GiftList>('/gifts', {
      params: options,
    });
    console.log(response.data)
    return response.data;
  }

  async getById({ id }: { id: number }): Promise<Gift> {
    const response = await this.instance.get<Gift>(`/gifts/${id}`, {
      params: {
        dbOnly: false,
      },
    });
    return response.data;
  }
}
